import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOPerfilAssistencia = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="PERFIL DA ASSISTÊNCIA DE TERAPIA OCUPACIONAL" />
                    <CheckContainer>
                        <HeaderVerde texto="Clientela" />
                        <CheckBox texto="Criança de 0 a 3 anos " grupo="toperfilassit" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Infantojuvenil" grupo="toperfilassit" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Adulto" grupo="toperfilassit" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Idoso" grupo="toperfilassit" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <CheckContainer>
                        <HeaderVerde texto="Tipo de Atendimento" />
                        <CheckBox texto="Individual" grupo="toperfilatend" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Grupo" grupo="toperfilatend" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Telemonitoramento/Teleconsulta" grupo="toperfilatend" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atendimento Familiar" grupo="toperfilatend" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Visita Domiciliar" grupo="toperfilatend" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Visita Escolar" grupo="toperfilatend" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <CheckContainer>
                        <HeaderVerde texto="Atribuições como Técnico em Saúde Mental" />
                        <CheckBox texto="Educação em Saúde" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Admissão" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Acolhimento" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Trabalho em Equipe Intra e Intersetorial" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Visita Comunitária" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atendimento Familiar" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Triagem" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Matriciamento" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Oficinas Terapêuticas" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Elaboração de PTS com equipe" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        {/* <CheckBox texto="Não se Aplica" grupo="toatribumental" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" /> */}
                    </CheckContainer>

                    <HeaderVerde texto="INTERVENÇÕES (Terminologia Uniforme - AOTA)" />
                    <CheckContainer>
                        <HeaderVerde texto="Ocupações" />
                        <CheckBox texto="AVD" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="AIVD" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Lazer" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Brincar" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Descanso e Sono" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Educação" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Trabalho" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Gerenciamento e Saúde" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Participação Social" grupo="toperfilocup" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <CheckContainer>
                        <HeaderVerde texto="Habilidades de Desempenho" />
                        <CheckBox texto="Habilidades Motoras" grupo="toperfildesemp" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Habilidades de Processo (regulação sensorial, cognição, outros)" grupo="toperfildesemp" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Habilidades de Interações Sociais" grupo="toperfildesemp" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <CheckContainer>
                        <HeaderVerde texto="Recursos/Estratégias" />
                        <CheckBox texto="Estimulação Sensorial" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Estimulação Motora" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Estimulação Cognitiva" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atividades de Lazer" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atividades do Brincar" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Treinos de AVD" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="PIC´s" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Técnicas de Conservação de Energia" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Oficinas Terapêuticas" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Atividades em Grupo" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Educação e Orientação em Saúde" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Estruturação de Rotina" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Confecção/Adaptação de Órteses e outros Equipamentos de Tecnologia Assistiva" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Orientação Familiar/Cuidadores" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Integração Sensorial" grupo="toperfilrecurs" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>
                    <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                </Caixa>
            )
        }
        return partes
    }
}

export default TOPerfilAssistencia